import React from "react";

const SCRIPT = [
  { cmd: "whoami", out: ["Van Carlo Labanan"] },
  { cmd: "role --list", out: ["Developer", "Video Editor"] },
  { cmd: "status", out: ["Open to new projects"] },
];

const TYPE_SPEED = 28;
const LINE_PAUSE = 260;
const END_PAUSE = 1400;

function Terminal() {
  const [rows, setRows] = React.useState([]);
  const [runId, setRunId] = React.useState(0);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    let cancelled = false;
    setRows([]);

    function wait(ms) {
      return new Promise((resolve) => {
        timeoutRef.current = setTimeout(resolve, ms);
      });
    }

    async function typeText(text, onUpdate) {
      for (let i = 1; i <= text.length; i++) {
        if (cancelled) return;
        onUpdate(text.slice(0, i));
        // eslint-disable-next-line no-await-in-loop
        await wait(TYPE_SPEED);
      }
    }

    async function run() {
      for (let i = 0; i < SCRIPT.length; i++) {
        if (cancelled) return;
        const { cmd, out } = SCRIPT[i];

        setRows((prev) => [...prev, { type: "cmd", text: "" }]);
        // eslint-disable-next-line no-await-in-loop
        await typeText(cmd, (partial) => {
          setRows((prev) => {
            const next = [...prev];
            next[next.length - 1] = { type: "cmd", text: partial };
            return next;
          });
        });

        // eslint-disable-next-line no-await-in-loop
        await wait(LINE_PAUSE);

        for (const line of out) {
          if (cancelled) return;
          setRows((prev) => [...prev, { type: "out", text: line }]);
          // eslint-disable-next-line no-await-in-loop
          await wait(180);
        }

        if (cancelled) return;
        setRows((prev) => [...prev, { type: "spacer" }]);
      }
      if (cancelled) return;
      // eslint-disable-next-line no-await-in-loop
      await wait(END_PAUSE);
      if (cancelled) return;
      setRunId((id) => id + 1);
    }

    run();

    return () => {
      cancelled = true;
      clearTimeout(timeoutRef.current);
    };
  }, [runId]);

  return (
    <div
      className="terminal-window"
      role="button"
      tabIndex={0}
      title="Click to replay"
      onClick={() => setRunId((id) => id + 1)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") setRunId((id) => id + 1);
      }}
    >
      <div className="terminal-bar">
        <span className="terminal-dot" />
        <span className="terminal-dot" />
        <span className="terminal-dot" />
      </div>
      <div className="terminal-body">
        {rows.map((row, i) => {
          if (row.type === "spacer") {
            return <div key={i} className="terminal-spacer" />;
          }
          if (row.type === "cmd") {
            const isLastCmd =
              i === rows.length - 1 ||
              (i === rows.length - 2 &&
                rows[rows.length - 1]?.type === "spacer");
            return (
              <div key={i} className="terminal-line">
                <span className="terminal-prompt">&gt;</span> {row.text}
                {isLastCmd && <span className="terminal-cursor" />}
              </div>
            );
          }
          return (
            <div key={i} className="terminal-line terminal-out">
              {row.text}
            </div>
          );
        })}
        {rows.length === 0 && <span className="terminal-cursor" />}
      </div>
    </div>
  );
}

export default Terminal;
